module.exports = __webpack_public_path__ + "assets/img/shopline.09eaf7d3.png";